<template>
  <section class="appmain">
    <router-view :key="key"/>
  </section>
</template>

<script>
export default {
  name:'AppMain',
  computed:{
    key(){
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.appmain{
  top: 60px;
  position: fixed;
  width: 100%;
  height: 100%;
  right: 1px;
}

</style>


// WEBPACK FOOTER //
// src/views/Home/AppMain.vue